import BaseModel from './base_model';

export default class BaseModelComponent extends BaseModel {
    getStyleSelectors() {
        return {};
    }
    
    static CLASS = 'BaseModelComponent';
}
